import { t } from "@/i18n-js/instance";
import type { Event, FormScheduleValues } from "@circle-react/types";
import { useCustomizeUIData } from "@circle-react-shared/CustomizeUI";
import { Button } from "@circle-react-uikit/Button";
import { isRecurring } from "../../utils";
import { SubmitEditButton } from "../SubmitEditButton";

interface EventsFooterProps {
  event: Event | null;
  formScheduleValues?: FormScheduleValues;
  isCreating: boolean;
  isDirty: boolean;
  isRepeatsDirty: boolean;
  isStartsAtDirty: boolean;
  onSubmit: () => void;
  shouldHideAllEventOption: boolean;
}

export const EventsFooter = ({
  event,
  isCreating,
  isDirty,
  onSubmit,
  isStartsAtDirty,
  shouldHideAllEventOption,
  isRepeatsDirty,
  formScheduleValues,
}: EventsFooterProps) => {
  const { isSaving, onExit } = useCustomizeUIData();

  return (
    <>
      {!isCreating && (
        <div className="ml-auto flex space-x-4">
          {isDirty && (
            <>
              <Button type="button" onClick={onExit} variant="secondary">
                {t("cancel")}
              </Button>
              <SubmitEditButton
                type="submit"
                variant="circle"
                disabled={isSaving}
                onEditModeConfirm={onSubmit}
                event={event}
                isRecurringEvent={isRecurring(event)}
                isStartsAtDirty={isStartsAtDirty}
                isRepeatsDirty={isRepeatsDirty}
                shouldHideAllEventOption={shouldHideAllEventOption}
                formScheduleValues={formScheduleValues}
              >
                {event ? t("save_changes") : t("save_draft")}
              </SubmitEditButton>
            </>
          )}
        </div>
      )}
    </>
  );
};
